// organize-imports-ignore
import './style.static.less';
import '../base';
import { loadCurrentUser } from './react/services/CurrentUser';
import { renderInitialLoadingError } from './render-error';
import { initCompanyDesign } from './react/services/CompanyDesignProvider';

(async () => {
    initCompanyDesign();
    try {
        await loadCurrentUser();
        await import(/* webpackChunkName: 'si-app-main', webpackPreload: true */ './index');
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        renderInitialLoadingError(error);
    }
})();
